import React, { useState } from 'react';
const ConfirmationPopup = ({ message, onCancel, onConfirm }) => {
    const [remark, setRemark] = useState('');
    const [error, setError] = useState('');

    const handleConfirm = () => {
        if (!remark.trim()) {
            setError('*');
        } else {
            setError('');
            onConfirm(remark);
        }
    };
    const handleRemarkChange = (e) => {
        const value = e.target.value;
        setRemark(value);
        if (error && value.trim() !== '') {
            setError(false); // Clear the error once the user starts typing
        }
    };

    return (
    <div className="popup_overlay">
        <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>{message}</h4>
            <div className='remark_container'>
                <span className='me-3 remark_label'>Remark:  {error && <span style={{ color: 'red' }}>{error}</span>}</span>
                <textarea
                    type='text'
                    className='remark_text'
                    value={remark}
                    onChange={handleRemarkChange}
                    placeholder="Enter suspend remark"
                    style={{
                        border: '1px solid #ced4da',
                        padding: '10px',
                     
                        fontSize: '16px',
                        resize: 'none',  // Keep this if you want to prevent resizing
                        overflow: 'auto',  // Enable scrollbars when content overflows
                        transition: 'height 0.3s',
                        borderRadius: "5px",
                        outline:"none"

                      }}
                />
            </div>
            <div className="popup_btn_container">
                <button className="yes_btn" onClick={handleConfirm}>Yes</button>
                <button className="no_btn" onClick={onCancel}>No</button>
            </div>
        </div>
        </div>

    );
};

export default ConfirmationPopup;
